import { render } from "./lightbulb.vue?vue&type=template&id=1ac65aa5"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/lightbulb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ac65aa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac65aa5', __exports__)) {
    api.reload('1ac65aa5', __exports__)
  }
  
  module.hot.accept("./lightbulb.vue?vue&type=template&id=1ac65aa5", () => {
    api.rerender('1ac65aa5', render)
  })

}


export default __exports__